import React, { useEffect, useState, useRef } from "react";
import "./AllProducts.scss";
import HeaderSlider from "../../components/Slider/HeaderSlider";
import { useSelector, useDispatch } from "react-redux";
import {
  getAllCategories,
  fetchAsyncCategories,
} from "../../store/categorySlice";
import ProductList from "../../components/AllProductList/AllProductList";
import {
  fetchAsyncProducts,
  getAllProducts,
  getAllProductsStatus,
} from "../../store/productSlice";
import Loader from "../../components/Loader/Loader";
import { STATUS } from "../../utils/status";
import { Link } from "react-router-dom";
import Footer1 from "../../components/Footer/Footer1";

const AllProducts = () => {
  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState(1);
  const productsPerPage = 8; // Nombre de produits par page
  const scrollRef = useRef(null);

  useEffect(() => {
    dispatch(fetchAsyncProducts(50));
    dispatch(fetchAsyncCategories());
  }, [dispatch]);

  const products = useSelector(getAllProducts);
  const productStatus = useSelector(getAllProductsStatus);
  const categories = useSelector(getAllCategories);
  const carouselRef = useRef(null);

  // Calculer les produits à afficher
  const indexOfLastProduct = currentPage * productsPerPage;
  const indexOfFirstProduct = indexOfLastProduct - productsPerPage;
  const currentProducts = products.slice(
    indexOfFirstProduct,
    indexOfLastProduct
  );

  // Nombre total de pages
  const totalPages = Math.ceil(products.length / productsPerPage);

  // Gestion de la pagination
  const handleNextPage = () => {
    if (currentPage < totalPages) setCurrentPage(currentPage + 1);
  };

  const handlePrevPage = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };

  useEffect(() => {
    dispatch(fetchAsyncCategories());

    const intervalId = setInterval(() => {
      scrollLeft();
    }, 4000); // Change d'élément toutes les 3 secondes

    return () => clearInterval(intervalId);
  }, [dispatch]);

  const autoScroll = () => {
    if (carouselRef.current) {
      const { scrollWidth, scrollLeft, clientWidth } = carouselRef.current;

      if (scrollLeft < scrollWidth - clientWidth) {
        carouselRef.current.scrollBy({ left: 300, behavior: "smooth" });
      } else {
        carouselRef.current.scrollTo({ left: 0, behavior: "smooth" });
      }
    }
  };

  useEffect(() => {
    const intervalId = setInterval(autoScroll, 4000);
    return () => clearInterval(intervalId);
  }, []);

  const scrollLeft = () => {
    if (carouselRef.current) {
      carouselRef.current.scrollBy({ left: -300, behavior: "smooth" });
    }
  };

  const scrollRight = () => {
    if (carouselRef.current) {
      carouselRef.current.scrollBy({ left: 300, behavior: "smooth" });
    }
  };

  return (
    <main>
      <div className="slider-wrapper">
        <HeaderSlider />
      </div>
      <div className="main-content bg-whitesmoke">
        <div className="container">
          <div className="categories py-2">
            <div className="categories-item">
              <div className="carousel-container">
                <button className="carousel-btn left" onClick={scrollLeft}>
                  &lt;
                </button>
                <button className="carousel-btn right" onClick={scrollRight}>
                  &gt;
                </button>
                <div className="categories-carousel" ref={carouselRef}>
                  {categories.map((category) => {
                    const displayCategory = category?.name?.replace("-", " ");
                    return (
                      <Link
                        to={`/category/${category.id}`}
                        key={category.id}
                        className="category-card"
                      >
                        {/* Tu peux ajouter une image ou autre contenu ici si nécessaire */}
                        <div className="category-card-content">
                          <p className="category-name text-capitalize">
                            {displayCategory}
                          </p>
                        </div>
                      </Link>
                    );
                  })}
                </div>
              </div>
            </div>
            <div className="categories-item">
              <div className="title-md">
                <h3>See All Products</h3>
              </div>
              {productStatus === STATUS.LOADING ? (
                <Loader />
              ) : (
                <ProductList products={currentProducts} /> // Affiche les produits de la page actuelle
              )}
              {/* Pagination */}
              <div className="pagination">
                <button onClick={handlePrevPage} disabled={currentPage === 1}>
                  Previous
                </button>
                <span>
                  Page {currentPage} of {totalPages}
                </span>
                <button
                  onClick={handleNextPage}
                  disabled={currentPage === totalPages}
                >
                  Next
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <Footer1 /> */}
    </main>
  );
};

export default AllProducts;
